// extracted by mini-css-extract-plugin
export var container = "TestimonialScroll-module--container--02455";
export var dots = "TestimonialScroll-module--dots--aff05";
export var gallery = "TestimonialScroll-module--gallery--e3b32";
export var gallerytestimonials = "TestimonialScroll-module--gallerytestimonials--a531b";
export var img = "TestimonialScroll-module--img--a7921";
export var label = "TestimonialScroll-module--label--dd2a5";
export var maintitle = "TestimonialScroll-module--maintitle--ca598";
export var name = "TestimonialScroll-module--name--f9563";
export var nextArrowButton = "TestimonialScroll-module--nextArrowButton--c8908";
export var paragraph = "TestimonialScroll-module--paragraph--2f1ef";
export var prevArrowButton = "TestimonialScroll-module--prevArrowButton--65c2e";
export var scrollCard = "TestimonialScroll-module--scrollCard--943a7";
export var subtitle = "TestimonialScroll-module--subtitle--6175f";
export var wrapper = "TestimonialScroll-module--wrapper--473f2";